module.exports = __webpack_public_path__ + "img/222.86be6c66.jpg";